<template>
  <div class="header-wrapper">
    <header
      v-if="routeName !== 'Details'"
      class="header"
      :class="[{
        'header--open': isNavOpen && isMobile,
        'header-job': routeName === 'ApplicationForm' || routeName === 'JobDetail',
        'header-department': routeName !== 'Home',
        'header-home ': routeName === 'Home',
        'general-form-height': routeName === 'GeneralForm',
        'header-job-tracking-result': routeName === 'JobTrackingResult'
      }]"
    >
      <div class="header__container">
        <div
          class="header__nav b-flex b-ai-center b-jc-space-between"
          :class="{ 'header__nav--mobile': isMobile && isNavOpen }"
        >
          <ul class="logo b-flex">
            <li>
              <router-link to="/">
                <figure>
                  <img
                    class="logo__img"
                    :src="displayLogo"
                    alt=""
                  >
                </figure>
              </router-link>
            </li>
            <BurgerMenu class="header__burger" />
          </ul>
          <TopMenu
            class="header__menu"
            :class="{ hide: !isNavOpen }"
          />
        </div>
        <div
          v-if="routeName === 'ReferralPage'"
          class="referral-content"
          :class="{ hide: isNavOpen }"
        >
          <Breadcrumb
            v-if="!isMobile"
            :list="breadcrumbs"
          />
          <h2 class="referral-heading tx-bold m0">
            Be Our Referral Partner
          </h2>
        </div>
        <div
          v-if="routeName === 'MotivationalFitResult'"
          :class="{ hide: isNavOpen }"
        >
          <Breadcrumb
            v-if="!isMobile"
            :list="breadcrumbs"
          />
        </div>
        <div
          v-if="routeName === 'MotivationalFit' || routeName === 'PrivacyNotice'"
          class="referral-content referral-heading"
          :class="{ hide: isNavOpen }"
        >
          <div v-if="routeName === 'MotivationalFit'">
            <Breadcrumb
              v-if="!isMobile"
              :list="breadcrumbs"
            />
            <h2>Discover Your Fit</h2>
            <p>Start with Discover your fit to find the position that match with your interest & experience</p>
          </div>
          <h2
            v-else
            class="header__tnc"
          >
            Privacy Notice
          </h2>
        </div>
        <h1 v-show="showHeaderTitle">
          Info Karir Terbaru di Online Shop Blibli
        </h1>
      </div>
    </header>

    <div
      v-if="maskIsShown && isSticky"
      class="modal__mask"
      @click="showSearchMask(false)"
    />
  </div>
</template>

<script src="./js/header.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
@import './css/header.scss';

.scroll {
  @include mobile {
    margin-top: 30px;
  }

  max-height: 480px;
  overflow-y: scroll;
}
</style>
